import React, { useEffect, useState } from 'react';
import api from '../Services/api';
import '../react-calendar/Calendar.css';
import Calendar from '../react-calendar/Calendar'
import { Swiper, SwiperSlide } from "swiper/react";
import "./styles.css";
import SwiperCore, { EffectCoverflow, Pagination } from "swiper";
import "swiper/swiper-bundle.css";

SwiperCore.use([EffectCoverflow, Pagination]);


const ViverCalendario = () => {

  type ValuePiece = Date | null;

  type Value = ValuePiece | [ValuePiece, ValuePiece];

  const [calendarValue, onChange] = useState<Value>(new Date());
  const [calendarMonth, onClickMonth] = useState<Value>();
  const [calendarActiveStartDate, setCalendarActiveStartDate] = useState<Value>();
  const [calendarActiveAction, setCalendarActiveAction] = useState<Value>();
  const [dsEventosMes, setEventosMes] = useState<any[]>([]);
  const [dsEventosDia, setEventosDia] = useState<any[]>([]);


  function onChangeEvent(value: Value, event: any): void {
    setCalendarActiveAction(null);
    onChange(value);
  }

  function onActiveStartDateChangeHandler({ action, activeStartDate, value, view }: any): void {
    setCalendarActiveStartDate(activeStartDate);
    setCalendarActiveAction(action);
  }

  /**
  * Retorna o nome do mes em pt-br com a primeira letra em maiuscula
  * @param calendarValue Date
  * @returns 
  */
  const getMes = (calendarValue: Value) => {

    if (calendarValue) {

      var locale = "pt-br",
        month = calendarValue.toLocaleString(locale, { month: "long" });

      return `${month.charAt(0).toUpperCase()}${month.slice(1)}`;
    }
  }

  /**
  * Retorna o nome do mes em pt-br com a primeira letra em maiuscula
  * @param calendarValue Date
  * @returns 
  */
  const getDia = (calendarValue: Value) => {

    if (calendarValue) {
      let day = calendarValue as Date;
      return day.getDate() > 9 ? day.getDate().toString() : `0${day.getDate().toString()}`;
    }
  }

  /**
   * Formata data em yyyyy/MM/dd
   * @param dataDt 
   * @returns 
   */
  function getFormatedDate(dataDt: Date) {

    let day = dataDt.getDate() < 10 ? ('0' + dataDt.getDate().toString()) : dataDt.getDate().toString();
    let mon = (dataDt.getMonth() + 1) < 10 ? ('0' + (dataDt.getMonth() + 1).toString()) : (dataDt.getMonth() + 1).toString();

    return `${dataDt.getFullYear()}-${mon}-${day}`;
  }

  /**
   * Formata data em yyyy/MM
   * @param dataDt 
   * @returns 
   */
  function getFormatedYearMonth(dataDt: Date) {

    let mon = (dataDt.getMonth() + 1) < 10 ? ('0' + (dataDt.getMonth() + 1).toString()) : (dataDt.getMonth() + 1).toString();

    return `${dataDt.getFullYear()}-${mon}`;
  }

  /**
   * Trata troca de mes no calendario
   */
  useEffect(() => {

    // verifica se foi navegacao mes ou ano
    if (calendarActiveAction) {

      let dataStr: string = calendarActiveStartDate ? calendarActiveStartDate?.toString() : '';
      let dataDt = new Date(dataStr);

      let month = dataDt.getMonth() + 1;
      let year = dataDt.getFullYear();

      let dataDtIni = new Date(dataStr);
      let dataDtFim = addMonths(new Date(dataStr), 1);

      let strDtIni = getFormatedDate(dataDtIni);
      let strDtFim = getFormatedDate(dataDtFim);


      api.get(`/obterEventosMesPVM?v=1&ini=${strDtIni}T00:00:00Z&fim=${strDtFim}T00:00:00Z`)

        .then((response) => {

          const grouped = getGroupedDates(year, month, response.data.results);
          setEventosMes(grouped);

        })
        .catch((err) => {
          console.log('err', err);
        });
    }
    else {
      // seleciona os eventos do mes para fazer a contagem
      callCalendarEvents(dsEventosMes, calendarValue);
    }

    // inicializa os eventos do mes
    initEventos();

  }, [calendarActiveAction, calendarActiveStartDate, calendarMonth, calendarValue]);

  /**
   * Trata inicializacao do mes
   */
  useEffect(() => {

    let dataDt = new Date();

    let month = dataDt.getMonth() + 1;
    let year = dataDt.getFullYear();

    let dataDtIni = new Date();
    let dataDtFim = addMonths(new Date(), 1);

    let strDtIni = getFormatedDate(dataDtIni);
    let strDtFim = getFormatedDate(dataDtFim);


    api.get(`/obterEventosMesPVM?v=1&ini=${strDtIni}T00:00:00Z&fim=${strDtFim}T00:00:00Z`)

      .then((response) => {

        const grouped = getGroupedDates(year, month, response.data.results);
        setEventosMes(grouped);

        // inicializa os eventos do mes
        initEventos();

      })
      .catch((err) => {

        console.log('err', err);
      });

  }, []);

  /**
   * Chama a api e carrega os a contagem de eventos do mes e os evento do dia selecionado
   * @param month 
   * @param year 
   * @param data 
   */
  function callCalendarEvents(eventosDoMes: any[], data: Value) {

    // data default
    let dataStr: string = data ? data?.toString() : '';

    let eventos = eventosDoMes.filter((item: any) => {
      return new Date(item.Data).getDate() === new Date(`${dataStr}`).getDate()
        && new Date(item.Data).getMonth() === new Date(`${dataStr}`).getMonth()
        && new Date(item.Data).getFullYear() === new Date(`${dataStr}`).getFullYear();
    });

    setEventosDia(eventos);
  }

  /**
   * Inicializa os eventos do mes
   */
  function initEventos() {

    let dataStr: string = calendarValue ? calendarValue?.toString() : '';
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    let dataDtIni = `${getFormatedYearMonth(new Date())}-01`;
    let dataDtFim = addMonths(new Date(dataStr), 1);
    let strDtFim = getFormatedDate(dataDtFim);

    api.get(`/obterEventosMesPVM?v=2&ini=${dataDtIni}T00:00:00Z&fim=${strDtFim}T00:00:00Z`)

      .then((response) => {

        const grouped = getGroupedDates(year, month, response.data.results);

        // verifica se tem evento no dia de hoje
        setProximoDiaDeEvento(grouped, dataStr, calendarValue);

        let eventos = response.data.results.filter((item: any) => {
          return new Date(item.Data).getDate() === new Date(`${dataStr}`).getDate()
            && new Date(item.Data).getMonth() === new Date(`${dataStr}`).getMonth()
            && new Date(item.Data).getFullYear() === new Date(`${dataStr}`).getFullYear();
        });
        setEventosDia(eventos);

      })
      .catch((err) => {

        console.log('err', err);

      });
  }

  /**
   * Procura proximo dia do mes que tenha eventos
   * @param grouped 
   * @param dataStr 
   * @param calendarValue 
   */
  function setProximoDiaDeEvento(grouped: any[], dataStr: string, calendarValue: (Date | null) | [Date | null, Date | null]) {

    if (getFormatedDate(new Date(dataStr)) === getFormatedDate(new Date())) {
      let proximosEventos = null;
      let eventosDeHoje = grouped.find((e) => { return e.data === getFormatedDate(new Date(dataStr)); });

      if (!eventosDeHoje) {
        // caso nao tenho, procura o proximo dia com eventos no mes
        proximosEventos = grouped
          .sort((a, b) => {
            if (a.data < b.data) {
              return -1;
            } else if (a.data === b.data) {
              return 0;
            } else {
              return 1;
            }
          })
          .find((e) => {
            return e.data > getFormatedDate(new Date(dataStr))
              && e.qtd > 0;
          });
      }

      if (proximosEventos) {
        onChange(new Date(proximosEventos.data + "T03:00:00Z"));
      }
    }
  }

  let counters: any[] = [];
  /**
   * Agrupa os eventos do mes em dias e faz a contagem de quantidade de evento por dia
   * @param _year 
   * @param _month 
   * @param arrayMonth 
   * @returns 
   */
  function getGroupedDates(_year: number, _month: number, arrayMonth: { ID: number; Id: number; Title: string; Descricao: string; URL: { Url: string; Description: string; }; URL_descricao: string; Data: string; }[]) {

    let month = _month > 10 ? _month.toString() : `0${_month}`;
    let year = _year.toString();

    // agrupa por ano mes desconsiderando hora
    const groupedKeys = arrayMonth.reduce((group: { [key: string]: any[]; }, item) => {
      if (!group[getFormatedYearMonth(new Date(item.Data))]) {
        group[getFormatedYearMonth(new Date(item.Data))] = [];
      }
      group[getFormatedYearMonth(new Date(item.Data))].push(item);
      return group;
    }, {});

    // isola o mes ano solicitado
    let result = groupedKeys[`${year}-${month}`];


    if (result) {

      // agrupa por ano mes dia
      const groupedKeys2 = result.reduce((group: { [key: string]: any[]; }, item) => {
        let key = getFormatedDate(new Date(item.Data));
        if (!group[key]) {
          group[key] = [];
        }

        item._data = key;

        group[key].push(item);
        return group;
      }, {});

      // faz a contagem por data    
      for (let i in groupedKeys2) {

        let item = groupedKeys2[i];

        item.forEach(element => {

          let foundItem = counters.find((a) => { return a.data === i; });

          if (foundItem) {
            foundItem["qtd"]++;
          }
          else {
            counters.push({ "data": element["_data"], "qtd": 1 });
          }
        });

      }
    }
    console.log(counters);
    return counters;
  }

  /**
   * Adiciona meses a uma data
   * @param date 
   * @param months 
   * @returns 
   */
  function addMonths(date: Date, months: number) {

    date.setMonth(date.getMonth() + months);

    return date;
  }

  function renderObjectBody(data: any) {
    return { __html: data }
  }

  return (
    <div>

      <div className='viver-eventos-cal'>

        <Calendar
          onChange={onChangeEvent}
          value={calendarValue}
          onClickMonth={onClickMonth}
          locale={"PT-br"}
          minDate={new Date()}
          dataSet={dsEventosMes}
          onActiveStartDateChange={onActiveStartDateChangeHandler}
        />
      </div>

      <div className='viver-eventos-mes'>

        <div className='viver-cal-title'>
          <h3>{getMes(calendarValue)}</h3>
        </div>

        <hr></hr>

        <div className="swiper-wrapper-viver swiper">
          <div className="swiper-wrapper">

            {dsEventosDia.length > 0 && <Swiper id='progs'
              grabCursor={true}
              slidesPerView={1}
              initialSlide={0}
              spaceBetween={50}
              // navigation={true}
              pagination={{ clickable: true }}
            // height={200}
            >
              {dsEventosDia?.map((item, index) => (
                <SwiperSlide key={index} >
                  <div key={item?.ID}>
                    <div className='viver-cal-evento'>
                      <h4>{getDia(calendarValue)} - {item?.Title}</h4>
                      <span dangerouslySetInnerHTML={renderObjectBody(item?.Descricao)} />
                    </div>
                    <div>
                      <br></br>
                      <ul>
                        <li>Local: {item?.local}</li>
                        <li>Horário: {item?.horario}</li>
                      </ul>
                      <br></br>
                      
                      {item?.URL?.Url &&
                      <div className='viver-cal-inscricao'>
                        <a target='_blank' rel="noreferrer" href={item?.URL?.Url}>{item?.URL_descricao} <span>Faça sua inscrição &#8594;</span></a>
                      </div>}
                      <hr></hr>
                    </div>
                    
                    <br></br>
                  </div>
                </SwiperSlide>

              ))}</Swiper>}
            {dsEventosDia.length === 0 && <div className='msg-vazio'>nenhum evento cadastrado para esse dia!</div>}

          </div>
        </div>
      </div>



    </div>

  );
}
export default ViverCalendario;


// let mock =
// {
//   "results": [
//     {
//       "Id": 331,
//       "Title": "Evento de participação conjunta 1",
//       "ComplianceAssetId": null,
//       "Descricao": "333333Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem",
//       "URL": {
//         "__metadata": {
//           "type": "SP.FieldUrlValue"
//         },
//         "Description": "https://institucional.forluz.org.br/",
//         "Url": "https://institucional.forluz.org.br/"
//       },
//       "Data": "2023-06-28T03:00:00Z",
//       "URL_descricao": "Veja Aqui",
//       "ID": 1,
//       "GUID": "692c5770-529e-47d1-bf66-8c12bcb1546d"
//     },
//     {
//       "Id": 331,
//       "Title": "Evento de participação conjunta 1",
//       "ComplianceAssetId": null,
//       "Descricao": "333333Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem",
//       "URL": {
//         "__metadata": {
//           "type": "SP.FieldUrlValue"
//         },
//         "Description": "https://institucional.forluz.org.br/",
//         "Url": "https://institucional.forluz.org.br/"
//       },
//       "Data": "2023-06-26T03:00:00Z",
//       "URL_descricao": "Veja Aqui",
//       "ID": 1,
//       "GUID": "692c5770-529e-47d1-bf66-8c12bcb1546d"
//     },
//     {
//       "Id": 331,
//       "Title": "Evento de participação conjunta 1",
//       "ComplianceAssetId": null,
//       "Descricao": "22Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem",
//       "URL": {
//         "__metadata": {
//           "type": "SP.FieldUrlValue"
//         },
//         "Description": "https://institucional.forluz.org.br/",
//         "Url": "https://institucional.forluz.org.br/"
//       },
//       "Data": "2023-06-26T03:00:00Z",
//       "URL_descricao": "Veja Aqui",
//       "ID": 1,
//       "GUID": "692c5770-529e-47d1-bf66-8c12bcb1546d"
//     },
//     {
//       "Id": 331,
//       "Title": "Evento de participação conjunta 1",
//       "ComplianceAssetId": null,
//       "Descricao": "4444Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem",
//       "URL": {
//         "__metadata": {
//           "type": "SP.FieldUrlValue"
//         },
//         "Description": "https://institucional.forluz.org.br/",
//         "Url": "https://institucional.forluz.org.br/"
//       },
//       "Data": "2023-06-26T03:00:00Z",
//       "URL_descricao": "Veja Aqui",
//       "ID": 1,
//       "GUID": "692c5770-529e-47d1-bf66-8c12bcb1546d"
//     },
//     {
//       "Id": 1,
//       "Title": "Evento de participação conjunta 2",
//       "ComplianceAssetId": null,
//       "Descricao": "Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem",
//       "URL": {
//         "__metadata": {
//           "type": "SP.FieldUrlValue"
//         },
//         "Description": "https://institucional.forluz.org.br/",
//         "Url": "https://institucional.forluz.org.br/"
//       },
//       "Data": "2023-06-26T03:00:00Z",
//       "URL_descricao": "Veja Aqui",
//       "ID": 1,
//       "GUID": "692c5770-529e-47d1-bf66-8c12bcb1546d"
//     },
//     {
//       "Id": 1,
//       "Title": "Evento de participação conjunta",
//       "ComplianceAssetId": null,
//       "Descricao": "Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem",
//       "URL": {
//         "__metadata": {
//           "type": "SP.FieldUrlValue"
//         },
//         "Description": "https://institucional.forluz.org.br/",
//         "Url": "https://institucional.forluz.org.br/"
//       },
//       "Data": "2023-06-26T03:00:00Z",
//       "URL_descricao": "Veja Aqui",
//       "ID": 1,
//       "GUID": "692c5770-529e-47d1-bf66-8c12bcb1546d"
//     },
//     {
//       "Id": 2,
//       "Title": "Evento de participação SEI",
//       "ComplianceAssetId": null,
//       "Descricao": "Rich text - cadastrado",
//       "URL": {
//         "__metadata": {
//           "type": "SP.FieldUrlValue"
//         },
//         "Description": "https://institucional.forluz.org.br/",
//         "Url": "https://institucional.forluz.org.br/"
//       },
//       "Data": "2023-06-15T03:00:00Z",
//       "URL_descricao": "Clique aqui e veja mais",
//       "ID": 2,
//       "GUID": "65be7b82-d8d7-411c-a123-886e8c9068ac"
//     },
//     {
//       "Id": 3,
//       "Title": "Evento de participação SEI 2",
//       "ComplianceAssetId": null,
//       "Descricao": "Rich text - cadastrado 2",
//       "URL": {
//         "__metadata": {
//           "type": "SP.FieldUrlValue"
//         },
//         "Description": "https://institucional.forluz.org.br/",
//         "Url": "https://institucional.forluz.org.br/"
//       },
//       "Data": "2023-06-15T03:00:00Z",
//       "URL_descricao": "Clique aqui e veja mais",
//       "ID": 3,
//       "GUID": "51fc274a-9c46-4464-9c76-ef3674186b6d"
//     },
//     {
//       "Id": 4,
//       "Title": "Evento de participação SEI 3",
//       "ComplianceAssetId": null,
//       "Descricao": "Rich text - cadastrado 3",
//       "URL": {
//         "__metadata": {
//           "type": "SP.FieldUrlValue"
//         },
//         "Description": "https://institucional.forluz.org.br/",
//         "Url": "https://institucional.forluz.org.br/"
//       },
//       "Data": "2023-06-15T03:00:00Z",
//       "URL_descricao": "Clique aqui e veja mais",
//       "ID": 4,
//       "GUID": "f9f100cd-a5d5-4a1a-9bac-395af2e0fd10"
//     }
//   ]
// }